import styled from 'styled-components';

export const ContributorPersonWrapper = styled.div`
  text-align: center;
  margin: 1rem 0;
  padding: 0 2rem;
  @media screen and (max-width: 1023px) {
    margin: 1rem 0;
    padding: 0 1rem;
  }
  img {
    margin: 0 auto;
    padding-bottom: 3rem;
    @media screen and (max-width: 1023px) {
      padding-bottom: 3rem;
    }
  }
  .featured-person {
    margin-bottom: 2rem;

    .main-title {
      color: white;
      text-transform: capitalize;
      letter-spacing: 0;
      font-size: 2rem;
      line-height: 2rem;
      margin: 0;
      @media screen and (max-width: 1023px) {
        line-height: 1rem;
      }
      .extra-font {
        font-size: 2.3rem !important;
      }
    }
    .desc {
      color: white;
      font-weight: 100;
      margin-top: 1rem;
      @media screen and (max-width: 1023px) {
        margin-top: 0.525;
      }
    }
    .image {
      text-align: center;
    }
  }
  .deceased-person {
    .main-title,
    .desc {
      color: black;
    }
    .deceased-text {
      font-size: 0.75rem;
    }
  }
  .main-title {
    color: white;
    text-transform: capitalize;
    letter-spacing: 0;
    font-size: 1.4rem;
    line-height: 1.4rem;
    margin: 0;
    font-size: 25px;
    @media screen and (max-width: 1023px) {
      font-size: 1.2rem;
    }
  }
  .desc {
    color: white;
    font-weight: 100;
    margin-top: 1rem;
    font-size: 1rem;
    @media screen and (max-width: 1023px) {
      margin-top: 0.525;
    }
  }
  .image {
    text-align: center;
  }
  .contributor-description {
    background: rgba(255, 255, 255, 0.5);
    padding: 0;
    margin: 0 0 10px 0;
    position: relative;
    opacity: 0;
    height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 1s;
    &:before {
      content: '';
      position: absolute;
      top: -10px;
      left: 50%;
      margin-left: -10px;
      width: 0;
      height: 0;
      border-bottom: solid 10px rgba(255, 255, 255, 0.5);
      border-left: solid 10px transparent;
      border-right: solid 10px transparent;
    }
    &--active {
      height: 180px;
      opacity: 1;
      padding: 15px;
    }
  }

  /* The flip card container - set the width and height to whatever you want. We have added the border property to demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
  .flip-card {
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    perspective: 1000px; /* Remove this if you don't want the 3D effect */
    @media screen and (max-width: 1023px) {
      height: 150px;
    }
    /* overflow-y: scroll; */
  }

  /* This container is needed to position the front and back side */
  .flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;
    transition-delay: 0.6s;
  }

  /* Position the front and back side */
  .flip-card-front,
  .flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden; /* Safari */
    backface-visibility: hidden;
  }

  /* Style the front side (fallback if image is missing) */
  .flip-card-front {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 1s;
    border-width: 1px;
    border-style: solid;
    border-color: transparent;
    &:hover {
      border-color: white;
      cursor: pointer;
    }
  }

  /* Style the back side */
  .flip-card-back {
    background-color: white;
    color: black;
    transform: rotateY(180deg);
    overflow-x: hidden;
    overflow-y: auto;
    font-size: 14px;
    /* overflow-y: scroll; */
    div {
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
`;
